export const queryKeys = {
  products: () => ['products'] as const,
  categories: () => ['categories'] as const,
  bikesCategories: () => ['bikes-categories'] as const,
  categoryDetail: (slug: string, lang: string) => ['category', slug, lang] as const,
  comboProductDetail: (slug: string, lang: string) =>
    ['combo-product', slug, lang] as const,
  comboProducts: (lang: string) => ['combo-products', lang] as const,
  homeArticles: (lang: string) => ['articles', 'home', lang] as const,
  blogArticles: (lang: string, page: number, category: string) =>
    ['articles', 'list', lang, page, category] as const,
  articleCategories: (lang: string) => ['article-categories', lang] as const
}
